import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'
import { localize } from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr.json'
import { initI18nForVue2 } from '@invivodf/locales/src'
import { getLocaleForBrand } from '@invivodf/locales/src/localeByBrand'
import microFrontList from '@invivodf/micro-front-tools-config/micro-front-list.json'
import messagesEventBus from '@invivodf/micro-front-tools-config/messages-event-bus.json'
import { setMicroFrontToolsConfig } from '@b2ag/micro-front-tools'
import App from '@/App.vue'
import router from '@/router'

// Plugins and config shared by both worlds.
export function registerCommonPlugins(): void {
  Vue.config.productionTip = false

  Vue.use(VueLazyLoad, {
    preLoad: 1.3,
    attempt: 1,
    lazyComponent: true,
  })

  // vee-validate v3 — base locale (world-specific rules are installed afterwards)
  localize('fr', fr)

  setMicroFrontToolsConfig({
    MICRO_FRONT_LIST: microFrontList,
    MESSAGES_EVENT_BUS: messagesEventBus,
  })

  // @ts-expect-error : XJU à typer plus tard
  window.parentRouter = router
}

// Mounts the root app with the world-specific Vue options (store, provide, ...).
export function mountApp(options: Record<string, unknown> = {}): void {
  new Vue({
    router,
    ...options,
    i18n: initI18nForVue2(
      getLocaleForBrand(window.env.VUE_APP_CONTEXT).locale,
      Vue,
      getLocaleForBrand(window.env.VUE_APP_CONTEXT).lang,
    ),
    render: (h) => h(App),
  }).$mount('#app')
}
